
import { Component,  Mixins } from 'vue-property-decorator';
import { Actions, Mutations } from '@/ts/store/Constants';
import moment from 'moment';
import DateMethods from '@/mixins/DateMethods.vue';

@Component({})
export default class EventLogMethods extends Mixins(DateMethods) {
    public getEventLogType(message: any) {
        const messageParsed = JSON.parse(message);
        return  messageParsed.type;
    }

    public getEventLogDescription(message: any) {
        const messageParsed = JSON.parse(message);
        return  typeof messageParsed.description !== 'undefined' ? messageParsed.description : '';
    }

    public getEventLogDate(createdAt: any, parsedFormat: string = '') {
        if (moment().format('DD/MM/YYYY') ===  this.handleFormatedDate(createdAt, 'DD/MM/YYYY', false, parsedFormat !== '' ? parsedFormat : 'DD/MM/YYYY')) {
            return 'Today';
        }
        return this.handleFormatedDate(createdAt, 'YY-MM-DD', false, parsedFormat);
    }

    public getEventLogRecipients(recipients: any) {
        let recipientsStr: string = '';
        for (let index = 0; index < recipients.length; index++) {
            recipientsStr +=  typeof recipients[index].person !== 'undefined'
                ?   `${recipients[index].person.first_name} ${recipients[index].person.family_name}`
                :   recipients[index].name;
            recipientsStr += index < recipients.length - 1 ? ', ' : '';
        }

        return recipientsStr;
    }

    public getEventLogTitle(message: any, name: string) {
        const messageParsed = JSON.parse(message);
        switch (messageParsed.type) {
            case 'TICKET_ASSIGNEE':
                return `Ticket assignee ${name === 'full' ? ' - Ticket ' : '' }`;
                break;
            case 'TICKET_WATCHERS':
                return `Ticket watcher ${name === 'full' ? ' - Ticket ' : '' }`;
                break;
            case 'TICKET_STATUS':
                return `Ticket status changed ${name === 'full' ? ' - Ticket ' : '' }`;
                break;
            case 'TICKET_PRIORITY':
                return `Ticket priority changed ${name === 'full' ? ' - Ticket ' : '' }`;
                break;
            case 'TICKET_MESSAGE':
            case 'TICKET_MESSAGE_REPLY':
                return `Ticket message ${name === 'full' ? ' - Ticket ' : '' }`;
                break;
            case 'DOCUMENT_SIGN':
                return `Document signed ${name === 'full' ? ' - Document ' : '' }`;
                break;
            case 'DOCUMENT_NEW':
                return `New document ${name === 'full' ? ' - Document ' : '' }`;
                break;
            case 'EVENT_NEW':
                return `New event ${name === 'full' ? ' - Event ' : '' }`;
                break;
            case 'EVENT_DATES_UPDATE':
                return 'Event date has been changed';
                break;
            case 'MESSAGE_NEW':
            case 'MESSAGE_REPLY':
                return `New message ${name === 'full' ? ' - Conversation ' : '' }`;
                break;
            case 'NOTIFICATION_COMMENT_NEW':
                return `New comment ${name === 'full' ? ' - Broadcast ' : '' }`;
                break;
            case 'EVENT_COMMENT_NEW':
                return `New comment ${name === 'full' ? ' - Event ' : '' }`;
                break;
            default:
               break;
        }
    }

    public getEventLogTypeId(message: any) {
        const messageParsed = JSON.parse(message);
        switch (messageParsed.type) {
            case 'TICKET_ASSIGNEE':
            case 'TICKET_WATCHERS':
            case 'TICKET_STATUS':
            case 'TICKET_PRIORITY':
            case 'TICKET_MESSAGE':
            case 'TICKET_MESSAGE_REPLY':
                return messageParsed.ticket_id;
                break;
            case 'DOCUMENT_SIGN':
            case 'DOCUMENT_NEW':
                return messageParsed.document_id;
                break;
            case 'EVENT_NEW':
            case 'EVENT_DATES_UPDATE':
                return messageParsed.event_id;
                break;
            case 'MESSAGE_NEW':
            case 'MESSAGE_REPLY':
                return messageParsed.conversation_id;
                break;
            case 'NOTIFICATION_COMMENT_NEW':
                return messageParsed.notification_id;
                break;
            case 'EVENT_COMMENT_NEW':
                return messageParsed.event_id;
                break;
            default:
               break;
        }
    }

    public markAsSeen(logId: number,  isSeen: number) {
        if (!isSeen) {
            this.$store.dispatch(Actions.MAKE_EVENT_LOG_SEEN, logId);
        }
    }

    public previewEventLog(logId: number, message: any, isSeen: number) {
        if (!isSeen) {
            this.$store.dispatch(Actions.MAKE_EVENT_LOG_SEEN, logId);
        }

        const messageParsed = JSON.parse(message);

        switch (messageParsed.type) {
            case 'TICKET_ASSIGNEE':
            case 'TICKET_WATCHERS':
            case 'TICKET_STATUS':
            case 'TICKET_PRIORITY':
            case 'TICKET_MESSAGE':
            case 'TICKET_MESSAGE_REPLY':
                if (this.$route.name !== 'admin-tickets') {
                    this.$router.push({
                            name: 'admin-tickets',
                            params: { ticketId : messageParsed.ticket_id },
                        },
                    );
                } else {
                    this.$store.dispatch(Actions.OPEN_TICKET_MODAL, messageParsed.ticket_id);
                }
                break;
            case 'DOCUMENT_SIGN':
            case 'DOCUMENT_NEW':
                if (this.$route.name !== 'admin-documents') {
                    this.$router.push({
                            name: 'admin-documents',
                            params: { documentId : messageParsed.document_id },
                        },
                    );
                } else {
                    this.$store.dispatch(Actions.FETCH_CURRENT_DOCUMENT, { id: messageParsed.document_id, action: 'update' });
                }
                break;
            case 'EVENT_NEW':
            case 'EVENT_COMMENT_NEW':
            case 'EVENT_DATES_UPDATE':
                if (this.$route.name !== 'admin-events') {
                    this.$router.push({
                            name: 'admin-events',
                            params: { eventId : messageParsed.event_id },
                        },
                    );
                } else {
                    this.$store.commit(Mutations.UPDATE_ACTIVE_EVENT, messageParsed.event_id);

                    this.$nextTick(() => {
                        this.$store.commit(Mutations.EDIT_ACTIVE_EVENT);
                        this.$store.commit(Mutations.SHOW_EDIT_EVENT_FORM, 'edit-event');
                    });
                }
                break;
            case 'NOTIFICATION_COMMENT_NEW':
                if (this.$route.name !== 'admin-notifications') {
                    this.$router.push({name: 'admin-notifications'});
                }

                this.$store.commit(Mutations.UPDATE_ACTIVE_NOTIFICATION, messageParsed.notification_id);
                this.$store.commit(Mutations.EDIT_ACTIVE_NOTIFICATION);
                this.$store.commit(Mutations.SHOW_EDIT_NOTIFICATION_FORM, 'edit-notification');

                break;
            default:
               break;
        }

        this.$emit('eventLogClicked', logId);
    }

    public previewAppEventLog(logId: number, message: any, isSeen: number) {
        if (!isSeen) {
            this.$store.dispatch(Actions.MAKE_EVENT_LOG_SEEN, logId);
        }

        const messageParsed = JSON.parse(message);

        switch (messageParsed.type) {
            case 'TICKET_ASSIGNEE':
            case 'TICKET_WATCHERS':
            case 'TICKET_STATUS':
            case 'TICKET_PRIORITY':
            case 'TICKET_MESSAGE':
            case 'TICKET_MESSAGE_REPLY':
                this.$router.push({
                        name: 'tickets-details',
                        params: { ticketId : messageParsed.ticket_id },
                    },
                );
                break;
            case 'MESSAGE_NEW':
            case 'MESSAGE_REPLY':
                const currentNotification = this.$store.getters['Messages/getConversation'](messageParsed.conversation_id);

                this.$store.commit(Mutations.UPDATE_ACTIVE_CONVERSATION, messageParsed.conversation_id);
                this.$store.commit(Mutations.SET_STAFF_PROPERTY_ICON_LINK, currentNotification.propertyId);

                if (currentNotification.hasUnseenMessages === true) {
                    this.$store.dispatch(Actions.MARK_ACTIVE_CONVERSATION_AS_SEEN);
                }

                this.$router.push({
                        name: 'inbox-chat',
                        params: { inboxId : messageParsed.conversation_id },
                    },
                );
                break;
            default:
               break;
        }
    }
}
